import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/role.actions';
import * as home from '../../../../actions/process.home.actions';
import * as inventory from '../../../../actions/process.inventory.actions';
import PanelInfo from '../../../labels/PanelInfo';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Snackbar from '../../../labels/Snackbar';

import Profesionals from './profesional';
import Applications from './application';

// eslint-disable-next-line
import style from './_style.css';

class Index extends React.Component {

    state = {
        id: undefined,
        clone: undefined
    }

    componentDidMount() {
        this.props.setInventoryWindow("roles");

        if(!this.props.id && !this.props.add && !this.props.clone ) {
            this.props.loadRoles();
            this.props.loadAppRoles();
        } else {
            if(!this.props.role || this.props.role.length === 0) {
                this.props.loadRoles();
                this.props.loadAppRoles();
            }
            this.props.loadInfo(this.props.id ? this.props.id : this.props.clone);
        }
    }

    componentDidUpdate() {
        this.props.setCurrentWindow(this.props.id && this.props.rol && this.props.rol.nombre  ?  this.props.rol.nombre : this.props.intl.formatMessage({id: 'roles_menu' }) );
    }

    static getDerivedStateFromProps(props, state) {
        if(props.id !== state.id || props.clone !== state.clone) {
            state.id = props.id;
            state.clone = props.clone;
            if(state.id) {
                props.loadInfo(props.id);
            }
            else if(state.clone) {
                props.loadInfo(props.clone);
            }
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleClick = (event) => {
        this.setState({open: true});
    }

    handleBack = () => {
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleError = (message, type) => {
        this.setState({error: message, errorType: type})
    }

    handleClose = () => {
        this.setState({ error: undefined, errorType: undefined });
    }

    render() {
        const { info, id, add, clone, roles_is_loading } = this.props;
        const { error, errorType } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '110' || f === '111') &&
              info.security.licencias.some((f) => f.id === 152 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {

            let levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            const manage = info.security.totalPermits.some((f) => f === '111' || f === '20' )
            const mylevel = info.security.nivelUsuario;
            if( !manage && mylevel > 1 ) {
                levels.splice(0, mylevel);
            }
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                  {roles_is_loading && <Loading open opacity />}
                   <div
                        className={
                                'flex_50  shadow_right_on_tablet bg_ice_blue ' +
                                (!!id ? 'hide' : '')
                            }
                    >
                        <Profesionals 
                            {...this.props} 
                            levels={levels} 
                            onError={this.handleError} 
                            />
                    </div>
                    {(!id && !add && !clone) && <PanelInfo id={'manage_aux_message'} />}
                    {(!!id || !!add || !!clone) && (
                        <div
                            className={
                                'flex_50 shadow_right_on_tablet bg_cloudy_blue_30 '
                            }
                        >
                            <Applications 
                                {...this.props} 
                                levels={levels} 
                                onError={this.handleError} 
                                />
                        </div>
                    )}  
                    {error && (
                        <Snackbar
                            open={true}
                            variant={errorType ? errorType : "error"}
                            text={error}
                            nonavbar={true}
                            onClose={this.handleClose}
                        />
                    )}             
                </div>
            );
        }
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
}

const mapStateToProps = (state) => {
    return {
        roles_is_loading: state.roles_is_loading,
        roles_has_errored: state.roles_has_errored,
        roles: state.roles,
        rol: state.rol,
        roles_app: state.roles_app,
        info: state.info,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home, inventory), dispatch)
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)))



// WEBPACK FOOTER //
// ./src/components/complex/manage/roles/Index.js